"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var ArrowUpward_1 = __importDefault(require("@material-ui/icons/ArrowUpward"));
var ArrowDownward_1 = __importDefault(require("@material-ui/icons/ArrowDownward"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, typography = _a.typography;
    return ({
        icon: {
            marginLeft: spacing(0.5),
            marginTop: spacing(0.3),
            fontSize: "".concat(typography.subtitle2.fontSize, " !important")
        }
    });
});
var SortingIcon = function (props) {
    var sortOrder = props.sortOrder, sortField = props.sortField, id = props.id;
    var classes = useStyles();
    var Icon = (0, react_1.useMemo)(function () { return (id === sortField && sortOrder === 0 ? ArrowUpward_1.default : ArrowDownward_1.default); }, [id, sortField, sortOrder]);
    return (react_1.default.createElement(Icon, { classes: { root: classes.icon } }));
};
exports.default = SortingIcon;
